<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onResize } from '@/utils/responsive'

export default {
  name: 'App',
  mounted() {
    // 检测设备类型
    this.updateDeviceType()
    
    // 监听窗口大小变化
    this.resizeHandler = onResize(() => {
      this.updateDeviceType()
    })
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      this.resizeHandler()
    }
  },
  methods: {
    updateDeviceType() {
      const width = window.innerWidth || document.documentElement.clientWidth
      let deviceType = 'primary'
      
      if (width <= 767) {
        deviceType = 'mobile'
      } else if (width >= 768 && width <= 1024) {
        deviceType = 'tablet'
      } else if (width >= 1080) {
        deviceType = 'primary'
      }
      
      this.$store.dispatch('app/setDeviceType', deviceType)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/common.scss';
</style>

